import React, { useEffect } from 'react';
import Footer from '@/components/Footer';
import Breadcrumbs from '@/components/Breadcrumbs';
import { DetailedInfo } from '@/components/products/pre-workout';
import SalesSection from '@/components/products/pre-workout/SalesSection';
import IngredientsOverview from '@/components/products/pre-workout/IngredientsOverview';
import PwoFaqSection from '@/components/products/pre-workout/PwoFaqSection';

const PreWorkout = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Norges høyest doserte stimulant-frie pre-workout | Peveo Competition PWO";

    const setMeta = (name: string, content: string, property?: boolean) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.content = content;
    };

    const desc = "Peveo Competition PWO Stim-Free: 10 000 mg L-Citrulline, 5 000 mg Betaine, 3 000 mg L-Tyrosine, 3 000 mg Taurine. 31g per porsjon – nesten 3x markedsstandard. Norges best doserte pre-workout.";
    setMeta('description', desc);
    setMeta('og:title', 'Norges høyest doserte stimulant-frie pre-workout | Peveo', true);
    setMeta('og:description', desc, true);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 mt-4">
        <Breadcrumbs />
      </div>
      <div className="container mx-auto px-4 py-16">
        <SalesSection />

        <div className="border-t border-border pt-12">
          <h2 className="text-3xl font-bold text-foreground text-center mb-8 font-orbit">
            Vitenskapelig dokumentasjon
          </h2>
          <p className="text-center text-muted-foreground mb-12 max-w-3xl mx-auto">
            Dykk ned i den komplette vitenskapelige analysen av hver ingrediens og hvorfor vi har valgt nøyaktig disse dosene.
          </p>
          <DetailedInfo />
        </div>

        <PwoFaqSection />
      </div>
      <Footer />
    </div>
  );
};

export default PreWorkout;
